import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import Breadcrumbs from "/react4xp/components/shared/Breadcrumbs/Breadcrumbs";
import type { SubPageHeaderPartProps } from "./SubPageHeader.d";

export const SubPageHeaderPart = (props: ComponentProps<PartData>) => {
  const { breadcrumbs, background } =
    (props.data as SubPageHeaderPartProps) ?? {};

  const formattedBreadcrumbs = breadcrumbs.map(
    (item) => [item.title, item.url || "#"] as [string, string],
  );

  let backgroundClass = "bg-red-50";
  if (background === "light-red") {
    backgroundClass = "bg-red-25";
  }
  return (
    <section className={backgroundClass}>
      <Breadcrumbs items={formattedBreadcrumbs} />
    </section>
  );
};

export default SubPageHeaderPart;
